const {KitModule, registerModule} = window;

const BATCH_SIZE = 24;

class FilteredPostGrid extends KitModule {
  constructor($element) {
    super($element);
    // elements
    this.$cards = [...this.$element.querySelectorAll('.card2')];
    // properties
    this.filterKey = this.$element.getAttribute('data-filter-key');
    this.visibleCount = BATCH_SIZE;
    // events
    this.$filterList.addEventListener('click', this);
    // lazy load via IntersectionObserver
    if (this.$sentinel) {
      this.observer = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) this.loadMore();
        },
        {rootMargin: '200px'},
      );
      this.observer.observe(this.$sentinel);
    }
    // initialize
    this.updateFilter();
  }

  onclick(event) {
    const $btn = event.target.closest('.btn');
    if (!$btn) return;

    // do not go to new page, do updateFilter
    event.preventDefault();
    // un-select when selected button clicked
    const href = $btn === this.$selectedButton ? '.' : $btn.href;
    window.history.replaceState({}, '', href);
    this.visibleCount = BATCH_SIZE;
    this.updateFilter();
  }

  loadMore() {
    this.visibleCount += BATCH_SIZE;
    this.updateFilter();
  }

  updateFilter() {
    const {search} = window.location;
    const params = new URLSearchParams(search);
    const filterValue = params.get( this.filterKey );
    const filterClass = `card2--${this.filterKey}-${filterValue}`;

    // filter cards, showing only up to visibleCount matching cards
    let shown = 0;
    let totalMatching = 0;
    this.$cards.forEach(($card) => {
      const matchesFilter = !filterValue || $card.classList.contains(filterClass);
      if (matchesFilter) {
        totalMatching++;
        $card.style.display = shown < this.visibleCount ? '' : 'none';
        if (shown < this.visibleCount) shown++;
      } else {
        $card.style.display = 'none';
      }
    });

    // update selected button
    if (this.$selectedButton) this.$selectedButton.classList.add('btn--dark');
    this.$selectedButton = search ? this.$filterList.querySelector(`[href="${search}"]`) : null;
    if (this.$selectedButton) this.$selectedButton.classList.remove('btn--dark');

    if (this.$sentinel) {
      this.$sentinel.style.display = shown < totalMatching ? '' : 'none';
    }
  }
}

registerModule('FilteredPostGrid', FilteredPostGrid);
